module.exports = __webpack_public_path__ + "img/arrow-right.8224e64a.svg";